import { get, type FieldValues } from "react-hook-form";

export const errorMessageAt = (
  errors: FieldValues,
  path: string,
): string | undefined => {
  const error = get(errors, path);
  if (error && typeof error === "object" && "message" in error) {
    return error.message as string | undefined;
  }
  return undefined;
};
